export default __webpack_public_path__ + "55fb7602b6489694cb5f84913d56ccbe.svg";